import { useEffect, useState } from 'react';

const getBreakpoint = (varName: string) => {
  if (typeof window === 'undefined') return 0;
  const root = getComputedStyle(document.documentElement);
  const emValue = root.getPropertyValue(varName).trim(); // e.g. "26.5625em"
  return parseFloat(emValue) * 16; // convert em to px
};

export const hookIsMobile = (breakpointVar = '--from-tablet') => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      const bp = getBreakpoint(breakpointVar);
      setIsMobile(window.innerWidth < bp);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, [breakpointVar]);

  return isMobile;
};
